import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import Icon, { ICON_TYPES } from '@commons/Icon';

import styles from './uploaderror.scss';
import { getTranslation } from '@services/translations';

const DEFAULT_CLOST_TEXT = "Close";

export default class UploadError extends PureComponent {
  constructor(props) {
    super(props);
    this.handleFileError = this.handleFileError.bind(this);
  }

  handleFileError(e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.onFileError(this.props.file);
  }

  render() {
    const { file } = this.props;
    const containerStyle = classNames(styles.container, styles.containerError);
    const closeButtonLabel = getTranslation('TA_CLOSE', DEFAULT_CLOST_TEXT);

    return (
      <li className={containerStyle}>
        {/* Added `role="alert"`  to ensure JAWS announces file upload errors. */}
        <span className={styles.errorMessage} id={`errorMessage-${file.order}`}>{file.errorMessage}</span>
        <button aria-label={closeButtonLabel} aria-describedby={`errorMessage-${file.order}`} className={styles.closeButton} onClick={this.handleFileError}>
          <Icon type={ICON_TYPES.CLOSE} containerStyles={styles.closeIcon} />
        </button>
      </li>
    );
  }
}

UploadError.propTypes = {
  file: PropTypes.shape({ [PropTypes.string]: PropTypes.any }).isRequired,
  onFileError: PropTypes.func.isRequired
};
